import React from "react";

function CompanyContact({
  stateObj,
  setStateObj,
  UpdateProfile,
  setCurrentDiv,
}) {
  return (
    <div className="row">
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Contact Person Name:</label>
          <input
            type="text"
            className="form-control"
            onChange={(e) =>
              setStateObj({
                ...stateObj,
                contactpersonname: e.target.value,
              })
            }
            value={stateObj.contactpersonname}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Contact Email:</label>
          <input
            type="email"
            id="contactEmail"
            className="form-control"
            name="contactEmail"
            onChange={(e) =>
              setStateObj({
                ...stateObj,
                email_contactperson: e.target.value,
              })
            }
            value={stateObj.email_contactperson}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Contact Phone:</label>
          <input
            onChange={(e) =>
              setStateObj({
                ...stateObj,
                mobile_contactperson: e.target.value,
              })
            }
            value={stateObj.mobile_contactperson}
            className="form-control"
            type="tel"
            id="contactPhone"
            name="contactPhone"
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Map Link:</label>
          <input
            onChange={(e) =>{
              if(stateObj.activestatus==="True")
                setStateObj({
                ...stateObj,
                googlelink: e.target.value,
              })
            }}
            value={stateObj.googlelink}
            readOnly={stateObj.activestatus!=="True"}
            className="form-control"
            placeholder={stateObj.activestatus!=="True" ? "Subscribe To Enter" :  "eg., https://maps.app.goo.gl/......"}
            type="text"
            id="googlelink"
            name="googlelink"
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Linkedin Profile:</label>
          <input
            type="text"
            id="socialMedia"
            name="socialMedia"
            className="form-control"
            placeholder={stateObj.activestatus!=="True" ? "Subscribe To Enter" : "e.g., https://www.linkedin.com/username"}
            readOnly={stateObj.activestatus!=="True"}
            onChange={(e) =>{
              if(stateObj.activestatus === "True")
              setStateObj({
                ...stateObj,
                linkedinprofile: e.target.value,
              })
            }}
            value={stateObj.linkedinprofile}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Instagram Profile:</label>
          <input
            type="text"
            id="instaprofile"
            name="instaprofile"
            className="form-control"
            placeholder={stateObj.activestatus!=="True" ? "Subscribe To Enter" : "e.g., https://www.instagram.com/username"}
            readOnly={stateObj.activestatus!=="True"}
            onChange={(e) =>{
              if(stateObj.activestatus === "True")
              setStateObj({
                ...stateObj,
                instaprofile: e.target.value,
              })
            }}
            value={stateObj.instaprofile}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Facebook Profile:</label>
          <input
            type="text"
            id="facebookprofile"
            name="facebookprofile"
            className="form-control"
            placeholder={stateObj.activestatus!=="True" ? "Subscribe To Enter" : "e.g., https://www.facebook.com/username"}
            readOnly={stateObj.activestatus!=="True"}
            onChange={(e) =>{
              if(stateObj.activestatus === "True")
              setStateObj({
                ...stateObj,
                facebookprofile: e.target.value,
              })
            }}
            value={stateObj.facebookprofile}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="linkedin">Company Address:</label>
          <textarea
            className="form-control"
            onChange={(e) =>
              setStateObj({ ...stateObj, address: e.target.value })
            }
            value={stateObj.address}
            id="address"
            name="address"
            required
          ></textarea>
        </div>
      </div>

      <div className="form-group">
        <button
          className="btn btn-primary "
          onClick={() => {
            UpdateProfile();
            setCurrentDiv("business");
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default CompanyContact;
